import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Works from '../Works/Works';

const WorkCaseStudies = () => {
    const [works, setWorks] = useState([]);

    useEffect(() => {
        fetch(`./OurWorks.json`)
            .then(res => res.json())
            .then(data => setWorks(data));
    }, [])
    const firstWorkServices = works.slice(0, 3);
    const secondWorkServices = works.slice(3, 6);
    return (
        <div>
            <Container sx={{ py: 4 }}>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={6}>
                        <Box id="right-margin">
                            <Typography variant="h4" sx={{ color: '#000D83', fontWeight: 600, fontSize: '48px', pt: 5, textAlign: 'left', pl: 2 }} id="work-title">
                                Case studies
                            </Typography>
                            {
                                firstWorkServices.map(work => <Works
                                    key={work.id}
                                    work={work}
                                ></Works>)
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <Box id="left-margin">
                            {
                                secondWorkServices.map(work => <Works
                                    key={work.id}
                                    work={work}
                                ></Works>)
                            }
                            <Typography id="display-visibility" sx={{ textAlign: 'left', pl: 2 }}>
                                <NavLink to="#" style={{ color: '#000D83', textDecoration: 'none', fontSize: '20px', fontWeight: 500 }}>View all case studies <i style={{ paddingLeft: '5px' }} className="fas fa-arrow-right"></i></NavLink>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Typography id="display-visible">
                    <NavLink to="#" style={{ color: '#000D83', textDecoration: 'none', fontSize: '17px', fontWeight: 500 }}>View all case studies <i style={{ paddingLeft: '5px' }} className="fas fa-arrow-right"></i></NavLink>
                </Typography>
            </Container>
        </div>
    );
};

export default WorkCaseStudies;